import settings from 'common/configs/setting';

export default (user) => {
    const { access_token, api_v2_key } = user || {};

    switch (settings.authType) {
        case 'bearer': {
            if (!access_token) {
                console.error('buildV2Authorization: access_token is missing');
                return '';
            }
            return `bearer ${access_token}`;
        }
        case 'apikey': {
            if (!api_v2_key) {
                console.error(
                    'buildV2Authorization: api_v2_key is missing from user state',
                    user
                );
                return '';
            }
            const authHeader = `Token ${api_v2_key}`;
            return authHeader;
        }
        default: {
            return '';
        }
    }
};
